const searchResult = ['hello world', 'checkout', 'hola']


export default searchResult;